export default __webpack_public_path__ + "static/media/WHAdmin.bfce8ef9.svg";